import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import { IoIosInformationCircle } from "react-icons/io";
import { FaUserPlus } from "react-icons/fa";
import "./Dashboard.css";

export default function ManageStatutory() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statutories, setStatutories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const complianceType = localStorage.getItem("compliance_type") || "statutory";
  const isDataBreach = complianceType === "data-breach";

  // Escalation states
  const [showEscModal, setShowEscModal] = useState(false);
  const [selectedComplianceId, setSelectedComplianceId] = useState(null);
  const [escalationEmail, setEscalationEmail] = useState("");
  const [reminderDays, setReminderDays] = useState(1);
  const [savingEsc, setSavingEsc] = useState(false);

  // Message states
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);

  const navigate = useNavigate();

  // -------------------- Fetch statutory compliances --------------------
  useEffect(() => {
  const fetchStatutories = async () => {
    try {
      setLoading(true);
      setError(null);

      const complianceType = localStorage.getItem("compliance_type");

      // ✅ single endpoint for all types
      const endpoint = "/compliance/fetch/regulatory";

      const res = await apiFetch(
        `${endpoint}?compliance_type=${encodeURIComponent(complianceType)}`,
        { method: "GET" }
      );

      const fetchedStatutories = Array.isArray(res?.data) ? res.data : [];

      fetchedStatutories.sort(
        (a, b) =>
          Number(a.regcmp_compliance_id) -
          Number(b.regcmp_compliance_id)
      );

      setStatutories(fetchedStatutories);
      setCurrentPage(1);

    } catch (err) {
      console.error(err);
      setError(`Failed to load compliances.`);
      setStatutories([]);
    } finally {
      setLoading(false);
    }
  };

  fetchStatutories();
}, []);

  // -------------------- Navigate to edit --------------------
  const handleView = (item) => {
    localStorage.setItem("complianceId", item.regcmp_compliance_id);
    navigate("/edit-compliance");
  };
  const handleAddCompliance = () => {
  const type = localStorage.getItem("compliance_type");

  if (type === "statutory") {
    navigate("/add-statutory");
  } 
  else if (type === "data-compliance") {
    navigate("/add-data_protection");
  }
  else if (type === "data-breach") {
    navigate("/add-data_breach");
  }
};

  // -------------------- Escalation save --------------------
  const handleEscalationSave = async () => {
    setErrors({});
    setSuccessMsg("");

    if (!escalationEmail) {
      setErrors({ escalation_email: "Required" });
      return;
    }

    if (!reminderDays || reminderDays < 1) {
      setErrors({ reminder_days: "Must be at least 1" });
      return;
    }

    try {
      setSavingEsc(true);

      const res = await apiFetch("/escalation/statutory", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          compliance_id: selectedComplianceId,
          escalation_email: escalationEmail,
          escalation_reminder_days: Number(reminderDays),
        }),
      });

      if (res?.error) throw res;

      setSuccessMsg("✅ Escalation updated successfully");
      setShowEscModal(false);
      setEscalationEmail("");
      setReminderDays(1);
    } catch (err) {
      console.error(err);
      setErrors({ api: err?.error || "❌ Failed to update escalation" });
    } finally {
      setSavingEsc(false);
    }
  };

  // -------------------- Auto-hide success --------------------
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const removeTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  // -------------------- Pagination --------------------
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = statutories.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.max(1, Math.ceil(statutories.length / rowsPerPage));

  return (
    <div className="manage-statutory">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main style={{ flex: 1, padding: "1rem 2rem", overflowY: "auto" }}>
         <h2>
   {localStorage.getItem("compliance_type") === "statutory"
    ? "Manage Statutory Compliances"
    : localStorage.getItem("compliance_type") === "data-compliance"
    ? "Manage Data Compliances"
    : "Data Breach Management"}
</h2>

          {/* Messages */}
          <div className="messages-top">
            {errors.api && <div className="login-error">{errors.api}</div>}
            {successMsg && (
              <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
                {successMsg}
              </div>
            )}
          </div>

          {/* Table */}
          <div className="table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Comp_ID</th>
                  <th>{isDataBreach ? "Specification" : "Act/Compliance"}</th>
<th>{isDataBreach ? "Phase" : "Particular"}</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                  <th>Escalation</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>Loading...</td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", color: "red" }}>{error}</td>
                  </tr>
                ) : statutories.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>No records found</td>
                  </tr>
                ) : (
                  currentRows.map((item, index) => (
                    <tr key={index}>
                      <td className="bold">{item.regcmp_compliance_id}</td>
                      <td>{item.regcmp_act}</td>
                      <td style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span>{item.regcmp_particular}</span>
                        {item.regcmp_description && (
                          <IoIosInformationCircle
                            title={item.regcmp_description}
                            style={{ cursor: "pointer", fontSize: "16px", color: "#1A1744" }}
                          />
                        )}
                      </td>
                      <td>{item.regcmp_start_date}</td>
                      <td>{item.regcmp_end_date}</td>
                      <td>
                        <button className="edit-btn" onClick={() => handleView(item)}>View</button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            setSelectedComplianceId(item.regcmp_compliance_id);
                            setShowEscModal(true);
                          }}
                          style={{
                            background: "#1a1744",
                            border: "none",
                            padding: "6px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                        >
                          <FaUserPlus size={14} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* Add Compliance Button */}
<div
  style={{
    marginTop: "20px",
    display: "flex",
    justifyContent: "center"
  }}
>
  <button
    onClick={handleAddCompliance}
    style={{
      background: "#1a1744",
      color: "#fff",
      border: "none",
      padding: "10px 16px",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: "500"
    }}
  >
    + Add New
  </button>
</div>

          {/* Pagination */}
         
            <div className="pagination">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((p) => p - 1)}
  >
    Prev
  </button>

  <span>
    Page {currentPage} of {totalPages}
  </span>

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage((p) => p + 1)}
  >
    Next
  </button>
</div>
          
        </main>
      </div>

      {/* Escalation Modal */}
      {showEscModal && (
        <div
          onClick={() => {
            setShowEscModal(false);
            setEscalationEmail("");
            setReminderDays(1);
            setErrors({});
          }}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "320px",
            }}
          >
            <h4>Add Escalation Email</h4>

            <input
              type="email"
              placeholder="Enter escalation email"
              value={escalationEmail}
              onChange={(e) => setEscalationEmail(e.target.value)}
              style={{ width: "100%", padding: "8px", marginTop: "10px", marginBottom: "5px" }}
            />
            {errors.escalation_email && <span className="error">{errors.escalation_email}</span>}

            <input
              type="number"
              min="1"
              placeholder="Reminder days"
              value={reminderDays}
              onChange={(e) => setReminderDays(e.target.value)}
              style={{ width: "100%", padding: "8px", marginTop: "10px" }}
            />
            {errors.reminder_days && <span className="error">{errors.reminder_days}</span>}

            <button
              onClick={handleEscalationSave}
              disabled={savingEsc}
              style={{
                background: "#1a1744",
                color: "#fff",
                border: "none",
                padding: "8px 12px",
                marginTop: "10px",
                width: "100%",
                cursor: "pointer",
              }}
            >
              {savingEsc ? "Saving..." : "Save Escalation"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}